<template>
  <div class="benefits">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/vorteile">Vorteile</router-link>
    </Breadcrumb>
    <div class="wrapper margin-top--40 margin-bottom--80">
      <Headline subline="E-Government" headline="Vorteile einer digitalen Verwaltung" />
      <Card padding="0px" v-for="benefit in benefits" :key="benefit.id" class="benefit">
        <div class="row between-xs">
          <div class="col-xs-12 col-md-6 benefit__text">
            <h3>{{ benefit.title }}</h3>
            <div class="greenline margin-top--10 margin-bottom--20"></div>
            <p>{{ benefit.description }}</p>
          </div>
          <div class="col-xs-12 col-md-5 benefit__illu">
            <img :src="benefit.illustration">
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '../../components/Icon/Icon';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Card from '../../components/Card/Card';

export default {
  name: 'Benefits',
  components: {
    Icon,
    Headline,
    Breadcrumb,
    Card,
  },
  data() {
    return {
      msg: 'Behördengänge einfach Online erledigen',
    };
  },
  computed: {
    ...mapGetters({
      benefits: 'benefits/getAllBenefits',
    }),
  },
  methods: {
    ...mapMutations({
        login: 'auth/login',
        logout: 'auth/logout',
      }),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Benefits.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Benefits/Benefits.vue